import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NewTmpComponent } from 'src/app/quote-template-new/new-tmp/new-tmp.component';

@Component({
    selector: 'app-template-not-save',
    templateUrl: './template-not-save.component.html',
    styleUrls: ['./template-not-save.component.scss'],
    standalone: false
})
export class templateNotSavingComponent implements OnInit, OnDestroy {
  private _unsubscribeAll: Subject<any> = new Subject();
  titleMsg:any;
  ItemsDeleteModule:any;
  constructor( public dialogRef: MatDialogRef<templateNotSavingComponent>,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialog: MatDialog,

  ) { }

  ngOnInit(): void {
    if(this.data){
      this.titleMsg = this.data?.title;
      this.ItemsDeleteModule=this.data?.message
    }
  }

  closeDialog() {
    this.dialogRef.afterClosed();
  }

  getTranslatedText(key: string): string {
    const translation = this.translateService.instant(key);
    return translation !== key ? translation : '';
  }
  viewQuote(){
    const diylogdata: any = { title: "Clone Quote Form", type: 'preview', data: this.data?.html };
    this.openDialog(diylogdata)
  }

  openDialog(data: any) {
    const dialogData: any = data;
    const dialogRef = this.dialog.open(NewTmpComponent, {
      panelClass: 'my-dialog-panel',
      width: data.type === 'preview' ? "870px" : "450px",
      data: dialogData,
      disableClose: true
    });
    dialogRef.afterClosed().pipe(takeUntil(this._unsubscribeAll)).subscribe((dialogResult) => {
   
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }
}
